import { useMemo } from 'react'

import { getDateFormats } from '../../../../formats'
import { form } from '../../formState'
import { useTexts } from './hooks/useTexts'

export function DateFormat() {
  const texts = useTexts()

  const dateFormats = getDateFormats()
  const options = useMemo(
    () =>
      Object.entries(dateFormats).map(([value, label]) => ({
        value,
        label,
      })),
    [dateFormats],
  )

  return (
    <form.SimpleSelect
      validateOn="blur change"
      options={options}
      testId="dateFormat"
      label={texts.dateFormat}
      name="dateFormat"
    />
  )
}
